<script>
  import { navigate } from "svelte-routing";

  import { UEX } from "../js/domains";
</script>

<div class="screen fullheight">
  <div class="screenheader nomargin">
    <div class="headertitletxt leftalign nomargin"><strong /></div>
    <img
      src="/images/logo-uex-white.png"
      loading="lazy"
      width="80"
      sizes="(max-width: 479px) 60px, (max-width: 767px) 55px, (max-width: 991px) 65px, 80px"
      srcset="/images/logo-uex-white-p-500.png 500w, /images/logo-uex-white.png 780w"
      alt=""
      class="logoheader"
    />
  </div>
  <div class="screenbody fullheight justifycenter">
    <div class="centercontent">
      <div class="formtitle headertitle">
        <strong>¡Gracias</strong> por completar este cuestionario!<br />
      </div>
      <div
        class="greenbuttonstyle widthlogin w-button"
        on:click={() => navigate(UEX, { replace: true })}
      >
        Aceptar
      </div>
    </div>
  </div>
  <div class="screenfooter">
    <img
      src="/images/logo-uex-complete-black.png"
      loading="lazy"
      width="300"
      sizes="(max-width: 479px) 83vw, 250px"
      srcset="/images/logo-uex-complete-black-p-500.png 500w, /images/logo-uex-complete-black-p-800.png 800w, /images/logo-uex-complete-black-p-1080.png 1080w, /images/logo-uex-complete-black-p-1600.png 1600w, /images/logo-uex-complete-black-p-2000.png 2000w, /images/logo-uex-complete-black-p-2600.png 2600w, /images/logo-uex-complete-black-p-3200.png 3200w, /images/logo-uex-complete-black.png 3994w"
      alt=""
      class="logobottom"
    />
  </div>
</div>
